<template>
    <pop :customClass="theme + ' iframe-container'" closeIcon="icon-close">
        <iframe width="100%" frameborder="0" height="100%" :src="url"></iframe>
    </pop>
</template>
<script>
export default {
    props: ['url', 'theme']
};
</script>
